import React, { ReactNode, forwardRef, JSX } from 'react';
import { Button, ButtonProps } from '../Button';
import { mergeClassAttributes } from '../../helpers/classes';

export type IconButtonProps = ButtonProps & {
  icon?: ReactNode;
  round?: boolean;
  iconSize?: number;
  'data-testid'?: string;
  'data-tip'?: boolean;
  'data-tooltip-id'?: string;
  labelledBy?: string;
  ariaLabel?: string;
};

const baseClasses = [
  'p-0',
  'text-[24px]',
  'w-[1.75em]',
  'h-[1.75em]',
  'justify-center',
];

export const IconButton = forwardRef(
  (props: IconButtonProps, ref): JSX.Element => {
    const {
      icon,
      round,
      rounded,
      labelledBy,
      ariaLabel,
      iconSize: _iconSize,
      ...rest
    } = props;

    const classes = [
      ...baseClasses,
      round || rounded ? 'rounded-full' : 'rounded',
    ];

    return (
      <Button
        {...rest}
        ref={ref}
        className={mergeClassAttributes(rest, classes)}
        aria-labelledby={labelledBy ?? rest['aria-labelledby']}
        aria-label={ariaLabel ?? rest['aria-label']}
      >
        {icon}
      </Button>
    );
  },
);

IconButton.displayName = 'IconButton';
